import { Component, ElementRef, inject, Inject, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Component({
  selector: 'app-condition-warranty',
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './condition-warranty.component.html',
  styleUrl: './condition-warranty.component.scss',
})
export class ConditionWarrantyComponent implements OnInit {
  @ViewChild('dialogContent', { static: false }) dialogContent!: ElementRef;

  private readonly loggingService = inject(LoggingService);

  constructor(public dialogRef: MatDialogRef<ConditionWarrantyComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  showButtonConfirm = false;
  isScrolledToBottom = false;

  ngOnInit() {
    this.loggingService.log('Received Data:', this.data.clickForm);
    if (this.data.clickForm === 'confirm') {
      this.showButtonConfirm = true;
    } else {
      this.showButtonConfirm = false;
    }
  }
  
  confirmAcceptance() {
    this.dialogRef.close(true); // Return '1' if user accepts
  }

  cancel() {
    this.dialogRef.close(null); // Return null if user cancels
  }
  onScroll(event: Event) {
    const target = event.target as HTMLElement;
    this.isScrolledToBottom = target.scrollHeight - target.scrollTop <= target.clientHeight + 10;
  }
}
